import { useFormContext } from 'react-hook-form';
import { FormField } from './BaseFormComponents';
import { BaseFormFieldWrapper } from './BaseFormFieldWrapper';
import {
  DatetimePicker,
  DatetimePickerProps,
} from './base-components/DateTimePicker';
import { FormComponentBaseProps } from './types/form-base-props';

export type FormDatePickerProps = Omit<FormComponentBaseProps, 'disabled'> &
  Omit<DatetimePickerProps, 'onSelect' | 'selected'> & {
    onChange?: (date: Date | null) => void;
  };

const FormDatePicker = ({
  description,
  descriptionProps,
  label,
  labelProps,
  hideError,
  defaultValue,
  name,
  onChange,
  disabled,
  required,
  ...props
}: FormDatePickerProps) => {
  const { control, watch, formState } = useFormContext();
  const { isSubmitting } = formState;
  const value = watch(name);

  return (
    <FormField
      shouldUnregister={false}
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={({ field }) => (
        <BaseFormFieldWrapper
          description={description}
          descriptionProps={descriptionProps}
          label={label}
          labelProps={labelProps}
          hideError={hideError}
          required={required}
        >
          <DatetimePicker
            {...field}
            {...props}
            disabled={disabled || isSubmitting}
            defaultMonth={value || defaultValue}
            onSelect={date => {
              field.onChange(date);
              onChange?.(date);
            }}
            selected={field.value}
          />
        </BaseFormFieldWrapper>
      )}
    />
  );
};

export { FormDatePicker };
